import TextField from '@/common/components/TextField'
import useDebounce from '@/common/hooks/useDebounce'
import { useScoredIntegrationCodes } from '@/features/modelIntegrationCodes/hooks/useScoredIntegrationCodes'
import ModelOption from '@/features/modelIntegrationCodes/pages/Show/components/ModelOption'
import {
  IntegrationCodeMatch,
  integrationCodeMatchKey,
} from '@/features/modelIntegrationCodes/types/suggestedModel.type'
import { SearchIcon } from 'lucide-react'

interface GeneralSearchTabProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
  selectedKey?: string
  onSelect: (model: IntegrationCodeMatch) => void
}

const GeneralSearchTab = ({ modelIntegrationCodeId, equipmentId, selectedKey, onSelect }: GeneralSearchTabProps) => {
  const [debouncedName, setName, name] = useDebounce('')
  const [debouncedManufacturer, setManufacturer, manufacturer] = useDebounce('')

  const {
    data: models = [],
    isPending,
    isFetching,
  } = useScoredIntegrationCodes({
    modelIntegrationCodeId,
    equipmentId,
    modelSearch: debouncedName,
    manufacturerSearch: debouncedManufacturer,
  })

  return (
    <div className="flex flex-col gap-2 flex-1 min-h-0">
      <div className="flex gap-2">
        <TextField
          LeftIcon={<SearchIcon />}
          placeholder="Busque por Nome"
          className="flex-1"
          value={name}
          onChange={(event) => setName((event.target as HTMLInputElement).value)}
          dataTestid="general_search_name"
        />

        <TextField
          LeftIcon={<SearchIcon />}
          placeholder="Busque por Fabricante"
          className="flex-1"
          value={manufacturer}
          onChange={(event) => setManufacturer((event.target as HTMLInputElement).value)}
          dataTestid="general_search_manufacturer"
        />
      </div>

      {!equipmentId ? (
        <p className="text-xs italic text-white-400">Selecione um equipamento para realizar a busca.</p>
      ) : isPending || isFetching ? (
        <p className="text-xs italic text-white-400">Carregando modelos...</p>
      ) : !models.length ? (
        <p className="text-xs italic text-white-400">Nenhum modelo encontrado.</p>
      ) : (
        <div className="flex flex-col gap-2 overflow-y-auto pr-2 flex-1">
          {models.map((model) => {
            const key = integrationCodeMatchKey(model)
            return (
              <ModelOption key={key} model={model} isSelected={selectedKey === key} onSelect={() => onSelect(model)} />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default GeneralSearchTab
